import { ReactNode } from 'react'

import CloseIcon from '@icons/Close'

import * as style from './style.module.sass'

type PopupProps = {
  children: ReactNode
  onClose?: () => void
}
const Popup = ({ children, onClose }: PopupProps) => {
  return (
    <div className={style.popup}>
      {children}

      <svg
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
        className="popupArrow"
      >
        <path
          d="M3.93116 0.987873C4.3073 0.280586 5.32085 0.280586 5.69699 0.987874L9.23009 7.63154C9.58431 8.29761 9.10157 9.10107 8.34718 9.10107H1.28097C0.526579 9.10107 0.043843 8.29761 0.398057 7.63154L3.93116 0.987873Z"
          fill="white"
        />
      </svg>
      {onClose !== undefined && (
        <button onClick={onClose}>
          <CloseIcon />
        </button>
      )}
    </div>
  )
}

export default Popup
